// auto-generated: do not change this file
<template>
<!--eslint-disable-->
  <div class="release-notes">
    <div class="release-note" data-date="2024-04-16T00:00:00Z"><div class="_dot"></div>
    <div class="_text">
        <div class="_date">
            April 16, 2024
        </div>
        <h2 class="_title">
            Real-time collaboration everywhere 🎉
        </h2>
        <div class="_tags">
            
        </div>
        <div class="_content">
            <p>Mooncamp is now fully collaborative! What does that mean?</p>
<p>Previously, when you were collaborating on the same page within Mooncamp, you had to reload the page to see the changes of your teammates. Frustrating! With real-time collaboration, you now immediately see any changes that are made to your goals, check-ins, dashboards, properties, or any other element or page you can think of. Even your reactions to check-ins or comments are updated in real-time 💯</p>
<p>P.S. Aside from a better user experience (e.g., when working together on a planning space), on the technical side, this change came with a new setup that allows us to release future features faster.</p>

<div class="image">
<video class="video -shortcode  -bordered -shadow" autoplay="" muted="" loop="" playsinline="" preload="auto" width="100%" height="auto" style="max-width: 100%">
    <source src="https://mooncamp.com/videos/collaboration.mp4" type="video/mp4"/>
</video>
</div>

        </div>
    </div>
</div><div class="release-note" data-date="2024-02-07T00:00:00Z"><div class="_dot"></div>
    <div class="_text">
        <div class="_date">
            February 08, 2024
        </div>
        <h2 class="_title">
            Housekeeping: Cleaning up the sidebar 🧹
        </h2>
        <div class="_tags">
            
        </div>
        <div class="_content">
            <p>In an effort to provide greater clarity, we rearranged a few menu items. We moved the <em>Planning</em> feature to the first level to make it more accessible and pulled the <em>Dashboards</em> feature into the <em>Tools</em> section. The <em>Trash</em> bin for goals is now located at the bottom of the sidebar.</p>
<p>We are currently working on a concept for enhanced team spaces and simplified access management. This sidebar modification is just the first step towards achieving better clarity and structure. Stay tuned!</p>

<div class="image ">
        <picture style="max-width: 100%">
            <source type="image/webp" srcset="https://mooncamp.com/images/illustrations/improved-sidebar-5eef21fe.webp"/>
            <source type="image/png" srcset="https://mooncamp.com/images/illustrations/improved-sidebar-6faf3599.png"/>
            <img alt="" src="https://mooncamp.com/images/illustrations/improved-sidebar-6faf3599.png"/>
        </picture>
</div>


        </div>
    </div>
</div><div class="release-note" data-date="2023-10-20T00:00:00Z"><div class="_dot"></div>
    <div class="_text">
        <div class="_date">
            October 23, 2023
        </div>
        <h2 class="_title">
            Introducing: Custom Goal Statuses 🚦🎉
        </h2>
        <div class="_tags">
            
        </div>
        <div class="_content">
            <p>You can now customize your goal statuses by renaming them, adding new statuses, and assigning scores.</p>
<p>Additionally, goal statuses are now divided into <strong>Active</strong> and <strong>Closed</strong> goals. Active goals are those that you are still working on, while closed goals are ones that have been completed or closed out. By default, you can close goals by marking them as “Achieved,” “Partial,” “Missed,” or “Dropped” (in case you decide to stop pursuing them). Of course, you can also define your own “Closed” statuses. Note that closed goals can still be edited if needed.</p>
<p>To learn more about goal statuses and scoring, visit our help center:
<a href="https://help.mooncamp.com/en/custom-goal-statuses" target="_blank" rel="noopener">English</a> – <a href="https://help.mooncamp.com/de/custom-goal-status" target="_blank" rel="noopener">German</a></p>

<div class="image ">
        <picture style="max-width: 100%">
            <source type="image/webp" srcset="https://mooncamp.com/images/illustrations/custom-goal-status-ea9686d3.webp"/>
            <source type="image/png" srcset="https://mooncamp.com/images/illustrations/custom-goal-status-e94e1bf1.png"/>
            <img alt="" src="https://mooncamp.com/images/illustrations/custom-goal-status-e94e1bf1.png"/>
        </picture>
</div>


        </div>
    </div>
</div><div class="release-note" data-date="2023-09-19T00:00:00Z"><div class="_dot"></div>
    <div class="_text">
        <div class="_date">
            September 19, 2023
        </div>
        <h2 class="_title">
            Duplicating dashboards and content cards
        </h2>
        <div class="_tags">
            
        </div>
        <div class="_content">
            <p>You can now duplicate your custom dashboards as well as the individual content cards they contain. By using an existing dashboard or content card as a template, you can streamline the process of creating and adjusting new odashboards.</p>

<div class="image">
<video class="video -shortcode  -bordered -shadow" autoplay="" muted="" loop="" playsinline="" preload="auto" width="100%" height="auto" style="max-width: 100%">
    <source src="https://mooncamp.com/videos/duplicate-dashboards.mp4" type="video/mp4"/>
</video>
</div>

        </div>
    </div>
</div><div class="release-note" data-date="2023-09-04T00:00:00Z"><div class="_dot"></div>
    <div class="_text">
        <div class="_date">
            September 6, 2023
        </div>
        <h2 class="_title">
            Introducing: Custom Dashboards 📈🎉
        </h2>
        <div class="_tags">
            
        </div>
        <div class="_content">
            <p>The first version of custom dashboards is here!</p>

<div class="image">
<video class="video -shortcode  -bordered -shadow" autoplay="" muted="" loop="" playsinline="" preload="auto" width="100%" height="auto" style="max-width: 100%">
    <source src="https://mooncamp.com/videos/custom-dashboards.mp4" type="video/mp4"/>
</video>
</div>
<p>Custom dashboards can be used for anything. Here are just a few of many use cases:</p>
<ul>
<li><strong>Company Cockpit:</strong> An executive summary encapsulating the company’s vision, mission, and values, as well as top-level KPIs and overall OKR progress.</li>
<li><strong>Quarterly Business Review (QBR):</strong> An in-depth analysis of quarterly achievements, growth, challenges, strategic initiatives, as well as OKR highlights and lowlights.</li>
<li><strong>Weekly Management Report:</strong> A report that highlights key accomplishments, challenges, and focus areas for the week, aiding in short-term decision-making and planning.</li>
<li><strong>Personal Dashboard:</strong> A tailored view featuring individual OKRs, your check-ins, personal notes, relevant files, and quick links to your team members public profiles.</li>
<li><strong>Department Overview:</strong> A comprehensive snapshot of a department’s mission, key metrics, goals, team members, and other possible reports, like OKR leaderboards.</li>
</ul>
<p>Head over to the new Insights section and start building your dashboards now 🚀</p>
<p>P.S. This is just the start: In the future, even more features, report types and use cases will be available! If you have suggestions for new insights or features that would make custom dashboards more valuable to you, do let us know by <strong>using the feedback button in the upper right corner</strong> of the screen 😍</p>
<p>Learn more about custom dashboards in our help center: <a href="https://help.mooncamp.com/en/custom-dashboards" target="_blank" rel="noopener">English</a> – <a href="https://help.mooncamp.com/de/custom-dashboards" target="_blank" rel="noopener">German</a></p>

        </div>
    </div>
</div><div class="release-note" data-date="2023-08-04T00:00:00Z"><div class="_dot"></div>
    <div class="_text">
        <div class="_date">
            August 8, 2023
        </div>
        <h2 class="_title">
            Quickly add relevant goals to your check-ins
        </h2>
        <div class="_tags">
            
        </div>
        <div class="_content">
            <p>We recently added new options to quickly add goals. You can now choose to either add all goals from your last check-in or all goals where you have been mentioned in a property (such as Owner, Contributor, etc.).</p>

<div class="image  -bordered -shadow">
        <picture style="max-width: 100%">
            <source type="image/webp" srcset="https://mooncamp.com/images/illustrations/check-in-quick-actions-222e4981.webp"/>
            <source type="image/png" srcset="https://mooncamp.com/images/illustrations/check-in-quick-actions-6cf49780.png"/>
            <img alt="" src="https://mooncamp.com/images/illustrations/check-in-quick-actions-6cf49780.png"/>
        </picture>
</div>


        </div>
    </div>
</div><div class="release-note" data-date="2023-08-02T00:00:00Z"><div class="_dot"></div>
    <div class="_text">
        <div class="_date">
            August 2, 2023
        </div>
        <h2 class="_title">
            Restore deleted goals from Trash
        </h2>
        <div class="_tags">
            
        </div>
        <div class="_content">
            <p>Say goodbye to that feeling of panic when you accidentally delete a goal. You can now restore deleted goals from a trash folder located at the bottom of the sidebar. From there, you can also choose to permanently delete a goal if you wish.</p>

<div class="image">
<video class="video -shortcode  -bordered -shadow" autoplay="" muted="" loop="" playsinline="" preload="auto" width="100%" height="auto" style="max-width: 100%">
    <source src="https://mooncamp.com/videos/goal-trash.mp4" type="video/mp4"/>
</video>
</div>

        </div>
    </div>
</div><div class="release-note" data-date="2023-07-13T00:00:00Z"><div class="_dot"></div>
    <div class="_text">
        <div class="_date">
            July 17, 2023
        </div>
        <h2 class="_title">
            Introducing: The Goal Tree 🌳🎉
        </h2>
        <div class="_tags">
            
        </div>
        <div class="_content">
            <p>If you’re on the Pro or Enterprise plan, you now have access to one of our most anticipated features: the goal tree view. Here are a few of the many ways you can use it:</p>
<ul>
<li>Use the goal tree view as a drawing board to map out all your strategic pillars, focus areas, goals, and initiatives in a hierarchical view.</li>
<li>Give everyone a high-level overview of your company’s strategy and the alignment of your goals and OKRs.</li>
<li>Zoom in on OKR sets of certain departments or focus areas.</li>
<li>Quickly discover isolated goals and align them under the correct parent goal.</li>
</ul>
<p>You can also create and edit goals directly from the goal tree view or rearrange them via drag and drop.</p>
<p>Learn more about the  goal tree in our help center: <a href="https://help.mooncamp.com/en/goal-tree" target="_blank" rel="noopener">English</a> – <a href="https://help.mooncamp.com/de/goal-tree" target="_blank" rel="noopener">German</a></p>

<div class="image">
<video class="video -shortcode  -bordered -shadow" autoplay="" muted="" loop="" playsinline="" preload="auto" width="100%" height="auto" style="max-width: 100%">
    <source src="https://mooncamp.com/videos/goal-tree.mp4" type="video/mp4"/>
</video>
</div>
<p>This is only the beginning! We actively listen to our customers and can’t wait to hear your ideas and suggestions for improving the new goal tree. If you like or dislike something, have ideas for additional goal tree features, or how we can improve it, we encourage you to <strong>use the feedback function at the bottom of the page</strong> and send all your brilliant ideas and feedback our way 😍.</p>
<div class="in-app-only">
   
<p v-if="treeViewLink !== null">
<m-btn :to="treeViewLink" color="primary">Try now</m-btn>
</p>

</div>

        </div>
    </div>
</div><div class="release-note" data-date="2023-04-20T00:00:00Z"><div class="_dot"></div>
    <div class="_text">
        <div class="_date">
            April 20, 2023
        </div>
        <h2 class="_title">
            Improvements to the sidebar
        </h2>
        <div class="_tags">
            
        </div>
        <div class="_content">
            <p>We have made some improvements to the sidebar: The first thing you might notice is that your personal Home view can now be found at the top of the sidebar for better visibility. In the near future, the Home view will receive an update that makes it more powerful and useful (once we have released our new “Custom Pages” and “Custom Dashboards” feature).</p>
<p>Another improvement is that you can now quickly access different views of your goals directly from the sidebar by clicking on the arrow next to team spaces. Lastly, “My workspace” is now called “Spaces” 🪐.</p>

<div class="image">
<video class="video -shortcode  -bordered -shadow" autoplay="" muted="" loop="" playsinline="" preload="auto" width="100%" height="auto" style="max-width: 100%">
    <source src="https://mooncamp.com/videos/new-sidebar.mp4" type="video/mp4"/>
</video>
</div>

        </div>
    </div>
</div><div class="release-note" data-date="2023-03-27T00:00:00Z"><div class="_dot"></div>
    <div class="_text">
        <div class="_date">
            March 28, 2023
        </div>
        <h2 class="_title">
            Inline editing for aligned items on goal detail pages
        </h2>
        <div class="_tags">
            
        </div>
        <div class="_content">
            <p>With inline editing you can now directly edit aligned items on the goal detail page, providing a faster and more efficient way to manage your goals.</p>
<p>This feature is part of our preparation work for the upcoming goal tree feature, which will allow you to visualize and manage the relationships between your goals in a tree view.</p>

<div class="image">
<video class="video -shortcode  -bordered -shadow" autoplay="" muted="" loop="" playsinline="" preload="auto" width="100%" height="auto" style="max-width: 100%">
    <source src="https://mooncamp.com/videos/goal-detail-page-inline-editing.mp4" type="video/mp4"/>
</video>
</div>

        </div>
    </div>
</div><div class="release-note" data-date="2023-02-10T00:00:00Z"><div class="_dot"></div>
    <div class="_text">
        <div class="_date">
            February 14, 2023
        </div>
        <h2 class="_title">
            Inline editing on cascade views
        </h2>
        <div class="_tags">
            
        </div>
        <div class="_content">
            <p>We are pleased to introduce a new feature that allows you to edit the content of your goals inline. Now you can quickly and easily modify your goals without having to open the goal detail page.</p>

<div class="image">
<video class="video -shortcode  -bordered -shadow" autoplay="" muted="" loop="" playsinline="" preload="auto" width="100%" height="auto" style="max-width: 100%">
    <source src="https://mooncamp.com/videos/goal-cascade-inline-editing.mp4" type="video/mp4"/>
</video>
</div>

        </div>
    </div>
</div><div class="release-note" data-date="2023-02-09T00:00:00Z"><div class="_dot"></div>
    <div class="_text">
        <div class="_date">
            February 09, 2023
        </div>
        <h2 class="_title">
            Introducing refined email notifications
        </h2>
        <div class="_tags">
            
        </div>
        <div class="_content">
            <p>With this improvement, your check-in and goal update notifications will now come with the check-in message and goal updates included. This allows you to see all the important details regarding your check-ins and goal progress directly in your emails.</p>

<div class="image ">
        <picture style="max-width: 100%">
            <source type="image/webp" srcset="https://mooncamp.com/images/illustrations/goal-update-emails-af574b40.webp"/>
            <source type="image/png" srcset="https://mooncamp.com/images/illustrations/goal-update-emails-261980d0.png"/>
            <img alt="" src="https://mooncamp.com/images/illustrations/goal-update-emails-261980d0.png"/>
        </picture>
</div>


        </div>
    </div>
</div><div class="release-note" data-date="2023-01-11T00:00:00Z"><div class="_dot"></div>
    <div class="_text">
        <div class="_date">
            January 11, 2023
        </div>
        <h2 class="_title">
            New formatting options for the goal description field
        </h2>
        <div class="_tags">
            
        </div>
        <div class="_content">
            <p>Enhancements to the “Description” field of goals now allow for the use of various formatting options.
You can include bullet points, numbered lists, file attachments, and image inserts.</p>

<div class="image ">
        <picture style="max-width: 100%">
            <source type="image/webp" srcset="https://mooncamp.com/images/illustrations/description-property-formatting-4180e377.webp"/>
            <source type="image/png" srcset="https://mooncamp.com/images/illustrations/description-property-formatting-22d29283.png"/>
            <img alt="" src="https://mooncamp.com/images/illustrations/description-property-formatting-22d29283.png"/>
        </picture>
</div>


        </div>
    </div>
</div><div class="release-note" data-date="2023-01-10T00:00:00Z"><div class="_dot"></div>
    <div class="_text">
        <div class="_date">
            January 11, 2022
        </div>
        <h2 class="_title">
            Introducing the new Resource Center
        </h2>
        <div class="_tags">
            
        </div>
        <div class="_content">
            <p>We’re excited to announce the launch of the Resource Center! The new resource center provides helpful video tutorials and resources on how to set, track, and reach OKRs to help you get the most out of Mooncamp. You can find the new resource center under “Help &amp; Support” at the bottom of the sidebar.</p>

<div class="image ">
        <picture style="max-width: 100%">
            <source type="image/webp" srcset="https://mooncamp.com/images/illustrations/resource-center-682af097.webp"/>
            <source type="image/png" srcset="https://mooncamp.com/images/illustrations/resource-center-284abb45.png"/>
            <img alt="" src="https://mooncamp.com/images/illustrations/resource-center-284abb45.png"/>
        </picture>
</div>


        </div>
    </div>
</div><div class="release-note" data-date="2022-11-30T00:00:00Z"><div class="_dot"></div>
    <div class="_text">
        <div class="_date">
            December 06, 2022
        </div>
        <h2 class="_title">
            Introducing the Health dashboard 🎉
        </h2>
        <div class="_tags">
            
        </div>
        <div class="_content">
            <p>With the Health dashboard, you can do a comprehensive health and quality check on all of your organization’s goals. Consider it a cockpit from where you can quickly identify and solve any issues with your goals, like missing property values, invalid parent goals, or measurement types.</p>
<p>This helps to ensure that your whole goal management process is running smoothly and that everyone follows the Goal and OKR rules that you configured in the settings area.</p>
<p>This is what one of our customers said: “The dashboard is like the OKR police!” 🚓</p>

<div class="image">
<video class="video -shortcode  -bordered -shadow" autoplay="" muted="" loop="" playsinline="" preload="auto" width="100%" height="auto" style="max-width: 100%">
    <source src="https://mooncamp.com/videos/health-dashboard.mp4" type="video/mp4"/>
</video>
</div>

        </div>
    </div>
</div><div class="release-note" data-date="2022-11-28T00:00:00Z"><div class="_dot"></div>
    <div class="_text">
        <div class="_date">
            November 29, 2022
        </div>
        <h2 class="_title">
            Introducing: The Pro Plan
        </h2>
        <div class="_tags">
            
        </div>
        <div class="_content">
            <p>We are introducing a new Professional Plan (”Pro” for short) that allows companies to use advanced features to execute their strategy and scale their OKR initiatives.</p>

<div class="image ">
        <picture style="max-width: 100%">
            <source type="image/webp" srcset="https://mooncamp.com/images/illustrations/pro-plan-introduction-f5af3c00.webp"/>
            <source type="image/png" srcset="https://mooncamp.com/images/illustrations/pro-plan-introduction-90b7fe80.png"/>
            <img alt="" src="https://mooncamp.com/images/illustrations/pro-plan-introduction-90b7fe80.png"/>
        </picture>
</div>


        </div>
    </div>
</div><div class="release-note" data-date="2022-11-18T00:00:00Z"><div class="_dot"></div>
    <div class="_text">
        <div class="_date">
            November 18, 2022
        </div>
        <h2 class="_title">
            Expanded and collapsed goals are saved
        </h2>
        <div class="_tags">
            
                <div class="_tag">
                    Improvement
                </div>
            
                <div class="_tag">
                    Goals &amp; OKRs
                </div>
            
        </div>
        <div class="_content">
            <p>Mooncamp now remembers which goals you expanded or collapsed in the cascade view, so they will appear just the way you left them the next time you open the app.</p>

<div class="image ">
        <picture style="max-width: 100%">
            <source type="image/webp" srcset="https://mooncamp.com/images/illustrations/store-expand-state-72fccfa6.webp"/>
            <source type="image/png" srcset="https://mooncamp.com/images/illustrations/store-expand-state-1c0c005d.png"/>
            <img alt="" src="https://mooncamp.com/images/illustrations/store-expand-state-1c0c005d.png"/>
        </picture>
</div>


        </div>
    </div>
</div><div class="release-note" data-date="2022-11-02T00:00:00Z"><div class="_dot"></div>
    <div class="_text">
        <div class="_date">
            November 2, 2022
        </div>
        <h2 class="_title">
            Dashboard improvements: Deeper insights into your goal progress
        </h2>
        <div class="_tags">
            
                <div class="_tag">
                    Improvement
                </div>
            
                <div class="_tag">
                    Goals &amp; OKRs
                </div>
            
        </div>
        <div class="_content">
            <p>New insights have been added to the breakdown report at the bottom of your performance dashboard.</p>
<p>The column “Progress” now shows the expected value and the absolute and relative change (in brackets) compared to the
previous period. The data in the column “Status/Confidence distribution” is clickable now, so you can see which goals
have which status and how many goals have moved between status segments compared to the last period. Finally, teams
are now presented in a nested structure.</p>

<div class="image  -bordered -shadow">
        <picture style="max-width: 100%">
            <source type="image/webp" srcset="https://mooncamp.com/images/illustrations/dashboard-performance-breakdown-23b95355.webp"/>
            <source type="image/png" srcset="https://mooncamp.com/images/illustrations/dashboard-performance-breakdown-ab809373.png"/>
            <img alt="" src="https://mooncamp.com/images/illustrations/dashboard-performance-breakdown-ab809373.png"/>
        </picture>
</div>


        </div>
    </div>
</div><div class="release-note" data-date="2022-10-26T00:00:00Z"><div class="_dot"></div>
    <div class="_text">
        <div class="_date">
            October 26, 2022
        </div>
        <h2 class="_title">
            Set dedicated icons for all of your goal types
        </h2>
        <div class="_tags">
            
                <div class="_tag">
                    Feature
                </div>
            
                <div class="_tag">
                    Goals &amp; OKRs
                </div>
            
        </div>
        <div class="_content">
            <p>With dedicated icons right next to the title of your goals, it is now easier to quickly scan your goal table and know what the type of each goal is. You can also choose to hide the “Type” column in your table to save some space as you already have the information available.</p>
<p>Are you a workspace admin and want to set icons for your goal types right now? Head over to your settings area and under “Types and rules”, you can now specify the icon and color for each of your goal types.</p>
<div class="in-app-only">
   
<p v-if="canEditGoalSettings">
<m-btn to="/goal/types" color="primary">Try now</m-btn>
</p>

</div>

<div class="image  -bordered -shadow">
        <picture style="max-width: 100%">
            <source type="image/webp" srcset="https://mooncamp.com/images/illustrations/goal-type-icons-b7d9785f.webp"/>
            <source type="image/png" srcset="https://mooncamp.com/images/illustrations/goal-type-icons-7e9d5f53.png"/>
            <img alt="" src="https://mooncamp.com/images/illustrations/goal-type-icons-7e9d5f53.png"/>
        </picture>
</div>


        </div>
    </div>
</div><div class="release-note" data-date="2022-10-04T00:00:00Z"><div class="_dot"></div>
    <div class="_text">
        <div class="_date">
            October 4, 2022
        </div>
        <h2 class="_title">
            New icon picker: Assign icons to goals, teams, views, and more
        </h2>
        <div class="_tags">
            
                <div class="_tag">
                    Improvement
                </div>
            
                <div class="_tag">
                    Goals &amp; OKRs
                </div>
            
        </div>
        <div class="_content">
            <p>Tired of emojis? 😩 You can now choose to assign icons to your teams, goals, favorites, or custom views.</p>

<div class="image ">
        <picture style="max-width: 100%">
            <source type="image/webp" srcset="https://mooncamp.com/images/illustrations/icon-picker-83d68fa7.webp"/>
            <source type="image/png" srcset="https://mooncamp.com/images/illustrations/icon-picker-54abfc2a.png"/>
            <img alt="Define top level goals" src="https://mooncamp.com/images/illustrations/icon-picker-54abfc2a.png"/>
        </picture>
</div>


        </div>
    </div>
</div>
  </div>
</template>

<script>
export default {
  name: 'ReleaseNotes',
  props: {
    unreadReleaseNotes: {
      type: Array,
      required: true,
    },
    canEditGoalSettings: {
      type: Boolean,
      default: false,
    },
    treeViewLink: {
      type: String,
      default: null,
    },
  },
  methods: {
    markNodesAsUnread() {
      const elements = document.querySelectorAll('.release-note');
      elements.forEach(el => {
        const d = el.getAttribute('data-date');
        if (this.unreadReleaseNotes.includes(d)) {
          el.classList += ' -unread';
        }
      })
    },
  },
  mounted() {
    this.markNodesAsUnread();
  },
 }
</script>

<style lang="scss" scoped type="text/scss">
  @import "shared/assets/scss/box-shadow";

  .release-note {
    position: relative;
    margin-bottom: 8rem;

    &.-unread {
      ._dot {
        position: absolute;
        top: 3.8rem;
        left: -3rem;
        width: 1rem;
        height: 1rem;
        background-color: map_get($blue, 'base');
        border-radius: .5rem;
      }
    }

    h2 {
      margin: 0;
    }

    img {
      width: 100%;
      height: auto;
    }

    ._text {
      font-size: $font-size-6;

      ._date {
        font-size: $font-size-2;
        font-weight: $font-weight-semibold;
        color: $font-color-secondary;
        text-transform: uppercase;
        letter-spacing: .05rem;
      }

      ._title {
        padding-top: .4rem;
        font-size: $font-size-9;
        color: $font-color-primary;
      }

      ._content {
        color: $font-color-primary;

        p {
          font-size: $font-size-6;
        }
      }

      ._tags {
        display: flex;
        flex-flow: wrap;
        margin-bottom: 1.4rem;

        ._tag {
          padding: .4rem 1.2rem;
          margin-top: 1rem;
          margin-right: 1rem;
          font-size: $font-size-4;
          line-height: 1.1;
          color: $font-color-secondary;
          border: .1rem solid map_get($grey, 'lighten-3');
          border-radius: $default-border-radius;
        }
      }
    }

    ._image {
      max-width: 100%;

      img {
        width: 100%;
        max-width: 100%;
        height: auto;
        border-radius: 0;
      }
    }

    .image {
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        border-radius: $default-border-radius;
      }

      &.-shadow {
        img {
          @include box_shadow(1);
        }
      }

      &.-highlighted {
        background: map_get($beige, 'base');

        img {
          margin-top: 4rem;
          margin-bottom: 4rem;
        }
      }

      video {
        @include box_shadow(1);
        border-radius: $default-border-radius;
        overflow: hidden;
      }

      .video {
        width: 100%;
        height: 100%;

        &.-shadow {
          @include box_shadow(1);
        }
      }
    }
  }
</style>
